export default "__VITE_ASSET__DV6fO9wK__"